import React, { useState } from 'react';
import { Box, Typography, Popover } from '@mui/material';
import { ChromePicker } from 'react-color';
import { styled } from '@mui/material/styles';

const ColorDisplay = styled(Box)(({ theme, color }) => ({
  width: '100%',
  height: 40,
  borderRadius: 4,
  border: '1px solid #ccc',
  backgroundColor: color || '#ffffff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 8px',
  cursor: 'pointer',
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
}));

const ColorText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.primary,
  fontFamily: 'monospace',
}));

const ColorPickerBase = ({ field, form, label, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [color, setColor] = useState(field.value || '#ffffff');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColorChange = (newColor) => {
    setColor(newColor.hex);
    form.setFieldValue(field.name, newColor.hex);
  };

  const open = Boolean(anchorEl);

  return (
    <Box>
      {label && (
        <Typography
          variant="body2"
          sx={{
            mb: 1,
            fontWeight: 500,
            color: 'text.primary',
          }}
        >
          {label}
        </Typography>
      )}
      <ColorDisplay color={color} onClick={handleClick}>
        <ColorText>{color}</ColorText>
        <Box
          sx={{
            width: 20,
            height: 20,
            borderRadius: '50%',
            backgroundColor: color,
            border: '2px solid #fff',
            boxShadow: '0 0 0 1px #ccc',
          }}
        />
      </ColorDisplay>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <ChromePicker
          color={color}
          onChange={handleColorChange}
          disableAlpha={true}
        />
      </Popover>
    </Box>
  );
};

export default ColorPickerBase;

